import { Data2, newId, dateToString } from '../../../features/data-types'
import { useSystemStateHooks } from '../../system'
import { CreditCard } from '../state/types'

export const useCreditCardBuilders = () => {
    const { companyId } = useSystemStateHooks()

    const buildCreditCard = (data: Data2) => {
        const { id = newId(), type, issuer, cardholder, last4Numbers, archived } = data
        const dueDate = dateToString(data.dueDate)!
        const creditCard: CreditCard = {
            companyId: companyId!,
            id: id! as string,
            type: type! as string,
            issuer: issuer! as string,
            cardholder: cardholder! as string,
            last4Numbers: last4Numbers! as number,
            dueDate,
            archived: !!archived
        }

        return creditCard
    }

    return {
        buildCreditCard
    }
}
